import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ProjectOverviewConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ProjectOverviewService } from './api/projectOverview.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ProjectOverviewApiModule {
    public static forRoot(configurationFactory: () => ProjectOverviewConfiguration): ModuleWithProviders<ProjectOverviewApiModule> {
        return {
            ngModule: ProjectOverviewApiModule,
            providers: [ { provide: ProjectOverviewConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ProjectOverviewApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ProjectOverviewApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
